import { render, staticRenderFns } from "./QuiltyResourceForm.vue?vue&type=template&id=f5d5b0e0&"
import script from "./QuiltyResourceForm.vue?vue&type=script&lang=ts&"
export * from "./QuiltyResourceForm.vue?vue&type=script&lang=ts&"
import style0 from "./QuiltyResourceForm.vue?vue&type=style&index=0&id=f5d5b0e0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5d5b0e0')) {
      api.createRecord('f5d5b0e0', component.options)
    } else {
      api.reload('f5d5b0e0', component.options)
    }
    module.hot.accept("./QuiltyResourceForm.vue?vue&type=template&id=f5d5b0e0&", function () {
      api.rerender('f5d5b0e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/quiltyResource/QuiltyResourceForm.vue"
export default component.exports